import { getSelectedEntrySelector } from '../../features/checkin/checkinSlice'
import useAppSelector from '../../hooks/useAppSelector'

const StorefrontItems = () => {
  const entry = useAppSelector(getSelectedEntrySelector)
  if (!entry) {
    return null
  }
  return (
    <>
      {entry.itemsPurchased.map((product, index) => (
        <div key={index}>{product.name} {product.size} ({product.quantity}) ({product.deliveryType})</div>
      ))}
    </>
  )
}

export default StorefrontItems
